import React from 'react';
import { BrowserRouter, /* HashRouter, Router,*/ Route, Switch } from 'react-router-dom';
import Home from '../Pages/Home';
import Teste from '../Pages/Teste';
import { ThemeProvider } from 'styled-components';
import theme from '../Styles/theme';

const Router = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename='/eventos'>
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/Teste' exact component={Teste} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
};

export default Router;
